import { useState, useCallback } from 'react';
import { useLeads } from '../../../contexts/leads/LeadsContext';

export const useKanbanDragDrop = () => {
    const { funnelStages, reorderStages } = useLeads();
    const [draggedColumnId, setDraggedColumnId] = useState<string | null>(null);

    const handleColumnDragStart = useCallback((e: React.DragEvent, stageId: string) => {
        e.dataTransfer.setData('type', 'column');
        e.dataTransfer.setData('stageId', stageId);
        setDraggedColumnId(stageId);
        e.dataTransfer.effectAllowed = 'move';
    }, []);

    const handleColumnDragOver = useCallback((e: React.DragEvent) => {
        e.preventDefault();
    }, []);

    const handleColumnDrop = useCallback((e: React.DragEvent, targetStageId: string) => {
        const type = e.dataTransfer.getData('type');
        if (type !== 'column') return;

        e.preventDefault();
        e.stopPropagation();

        const draggedId = e.dataTransfer.getData('stageId');
        if (!draggedId || draggedId === targetStageId) return;

        const currentOrder = funnelStages.map(s => s.id);
        const draggedIndex = currentOrder.indexOf(draggedId);
        const targetIndex = currentOrder.indexOf(targetStageId);

        if (draggedIndex === -1 || targetIndex === -1) return;

        const newOrder = [...currentOrder];
        newOrder.splice(draggedIndex, 1);
        newOrder.splice(targetIndex, 0, draggedId);

        reorderStages(newOrder);
        setDraggedColumnId(null);
    }, [funnelStages, reorderStages]);

    const handleDragEnd = useCallback(() => {
        setDraggedColumnId(null);
    }, []);

    return {
        draggedColumnId,
        handleColumnDragStart,
        handleColumnDragOver,
        handleColumnDrop,
        handleDragEnd
    };
};
